/**
 * Pastille d'accueil « comment utiliser » : le message ne doit pas
 * pousser un compte établi vers le menu Démarrage (masqué).
 */

export function resolveLaikaHowToUseMessage(args: {
  onboardingCompleted: boolean;
  newUserMessage: string;
  establishedMessage: string;
}): string {
  return args.onboardingCompleted ? args.establishedMessage : args.newUserMessage;
}
